import { render, staticRenderFns } from "./new-button.vue?vue&type=template&id=1ecaca36&scoped=true&"
import script from "./new-button.vue?vue&type=script&lang=js&"
export * from "./new-button.vue?vue&type=script&lang=js&"
import style0 from "./new-button.vue?vue&type=style&index=0&id=1ecaca36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecaca36",
  null
  
)

export default component.exports